import { useQuery } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

import {
  parseSemester,
  schoolYearSchema
} from '../constants/school-year-schemas'
import type { SchoolYear, SchoolYearResponse } from '../types'

const parseResponse = (response: SchoolYearResponse): SchoolYear => ({
  id: response.id,
  name: response.name,
  status: response.status,
  startDate: response.start_date,
  endDate: response.end_date,
  firstSemester: parseSemester(response.semesters[0]),
  secondSemester: parseSemester(response.semesters[1])
})

export const schoolYearQueryOptions = (yearId: string) => ({
  queryKey: ['panelPeriodsYearsRetrieve', yearId],
  staleTime: 60 * 1000,
  queryFn: async () => {
    const response = await httpService.panel.panelPeriodsYearsRetrieve(yearId, {
      fetchKeys: {
        id: true,
        name: true,
        semesters: true,
        start_date: true,
        end_date: true,
        status: true
      }
    })

    return parseResponse(schoolYearSchema.parse(response))
  }
})

export const useSchoolYear = (yearId: string) =>
  useQuery(schoolYearQueryOptions(yearId))
